// @file Anchor-rect helpers for OzPopoverModal, in a module of their own so a caller that only needs
// to compute an anchor does not import the popover component (and OzBox, OzOverlay and OzPopoverTip
// behind it) into its chunk. Re-exported from OzPopoverModal.vue for existing call sites.
import type { PopoverAnchor } from '@@/types'

function getAnchorFromCoordinates(
  x: number,
  y: number,
  offset: { top: number; left: number } = { top: 0, left: 0 },
): PopoverAnchor {
  return {
    top: y + offset.top,
    left: x + offset.left,
    width: 0,
    height: 0,
  }
}

function getAnchorFromElement(el: Element, offset: { top: number; left: number } = { top: 0, left: 0 }): PopoverAnchor {
  const rect = el.getBoundingClientRect()
  return {
    top: rect.top + offset.top,
    left: rect.left + offset.left,
    width: rect.width,
    height: rect.height,
  }
}

function isCompletePopoverAnchor(anchor: Partial<PopoverAnchor> | null | undefined): anchor is PopoverAnchor {
  return (
    anchor != null &&
    typeof anchor.top === 'number' &&
    typeof anchor.left === 'number' &&
    typeof anchor.width === 'number'
  )
}

export { getAnchorFromCoordinates, getAnchorFromElement, isCompletePopoverAnchor }
